 
 
    <div class="logout-container">
        <h1>Logging Out</h1>
        <p>You will be logged out shortly. Please wait...</p>
        <button onclick="window.location.href='/login'">Go to Login Page</button>
    </div>
 